import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ScrollablePageTab from "../../dynamicForm/components/ScrollablePageTab";
import EvidenceImageViewer from "../EvidenceImageViewer";

export default function EvidenceViewer({
  evidences,
  eventId,
  setSelectedEvidence,
}) {
  const [selectedPageIndex, setSelectedPageIndex] = useState(0);
  const [viewer, setViewer] = useState();

  useEffect(() => {
    if (selectedPageIndex >= 0) {
      setSelectedEvidence(evidences[selectedPageIndex]);
      setViewer(
        <EvidenceImageViewer
          paramId={eventId}
          paramType={evidences[selectedPageIndex].EvidenceType}
          paramEvidenceId={evidences[selectedPageIndex].Id}
          evidencesData={{ Data: evidences }}
          dontUseLoadingFullScreen
          galleryMode
        />
      );
    }
  }, [selectedPageIndex]);

  return (
    <Box sx={{ width: "850px", maxHeight: "500px" }}>
      {evidences && (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <ScrollablePageTab
            selectedPage={selectedPageIndex}
            setSelectedPage={setSelectedPageIndex}
            dynamicFormPages={evidences}
            maxWidthValue={"830px"}
          />

          {viewer}
        </Box>
      )}
    </Box>
  );
}
